<template>
    <div
        class="p-10 fixed inset-0 bg-black bg-opacity-80 flex flex-row justify-center items-center z-40"
        @click="$emit('cancel')"
    >
        <close-button @clicked="$emit('cancel')" />
        <div class="bg-white h-full flex flex-row justify-center items-center iframe-width">
            <iframe class="h-full iframe-width" :src="reportUrl"></iframe>
        </div>
    </div>
</template>

<script>
import CloseButton from "@/components/utilities/CloseButton.vue";

export default {
    name: "OldReportFrame",
    components: {
        CloseButton
    },
    props: {
        reportUrl: {
            type: String,
            required: true
        }
    }
};
</script>

<style scoped>
.iframe-width {
  width: 700px;
}
</style>
